<template>
  <div class="chart">
    <div class="page-container">
      <div class="board-container">
        <div class="board-item">
          <div class="board-title">会员总数</div>
          <div class="board-icon">
            <van-icon name="clock-o" />
          </div>
          <div class="board-number">
            {{ stat ? stat.total_customer : '-' }}
          </div>
        </div>
        <div class="board-item bg-blue">
          <div class="board-title">昨日新增</div>
          <div class="board-icon">
            <van-icon name="flag-o" />
          </div>
          <div class="board-number">
            {{ stat ? stat.new_customer : '-' }}
          </div>
        </div>
      </div>
      <div class="action-list">
        <div class="action-title">
          往期数据
        </div>
        <van-cell-group>
          <van-cell size="large" icon="video-o" title="观看人数" is-link to="/DisStat/play" />
          <van-cell size="large" icon="records" title="答题人数" is-link to="/DisStat/question" />
          <van-cell size="large" icon="gift-card-o" title="发布红包" is-link to="/DisStat/redpack" />
        </van-cell-group>
        <!--
        <div class="logout-function">
          <van-button plain type="info" block @click="doLogout">退出</van-button>
        </div>
        -->
      </div>
    </div>
    <Footer />
    <DisError />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import DisError from './component/DisError.vue';
import { mapState } from 'vuex'
import { baseStat } from '@/api/stats'

export default {
  name: 'DisChart',
  components: {
    Footer,
    DisError
  },
  data() {
    return {
      stat: null,
    }
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    init() {
      baseStat().then(async (resp) => {
        if ('data' in resp) {
          this.stat = resp.data
        }
      })
    },
    /*
    doLogout() {
      logout().then(async (resp) => {
        await this.$store.dispatch('syncUser')
        if ('state' in resp.data) {
          this.$router.replace('/login?state=' + resp.data.state)
        }
      })
    }
    */
  }
}
</script>
<style lang="scss" scoped>
.board-container {
  padding: 5px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;

  .board-item {
    width: calc(48vw - 10px);
    height: 30vw;
    position: relative;
    border-radius: 6px;
    background: #73b684;
    color: #fff;
    &.bg-blue {
      background: #7684e7;
    }
    .board-title {
      position: absolute;
      top: 12px;
      left: 12px;
    }
    .board-icon {
      position: absolute;
      right: 12px;
      top: 12px;
      font-size: 40px;
    }
    .board-number {
      position: absolute;
      bottom: 26px;
      left: 12px;
      font-size: 28px;
    }
  }
}
.action-list {
  padding: 5px 0;

  .action-title {
    padding: 0 0 5px 0;
    margin: 10px 0 15px 0;
    font-size: 16px;
    border-bottom: 4px solid #73b684;
    display: inline-block;
  }
  .logout-function {
    margin-top: 20px;
  }
}
</style>
